export enum Role {
    COMPANY = 'COMPANY',
    EMPLOYEE = 'EMPLOYEE',
    FREELANCE = 'FREELANCE',
    ROWNER = 'ROWNER'
}   

export type Service_Roles = Role.COMPANY | Role.EMPLOYEE | Role.FREELANCE;

export const Service_RolesArray = ['COMPANY', 'EMPLOYEE', 'FREELANCE', 'ROWNER'];

export const Product_RolesArray = [];